import {debounce} from "./utils/common";

export const filterSearch = () => {
  const filterSearchContainers = document.querySelectorAll(`.js-filter-search`);

  const filteringElements = (filterBlock) => {
    const searchInput = filterBlock.querySelector(`.js-filter-search-input`);
    const items = filterBlock.querySelectorAll(`.js-filter-search-item`);
    const showMoreButton = filterBlock.querySelector(`.js-filter-search-showmore`);

    const getFilteredElements = () => {
      const filterValue = searchInput.value.toLowerCase();

      items.forEach((element) => {
        if (element.dataset.value.toLowerCase().includes(filterValue)) {
          element.classList.remove(`hidden`);
          element.classList.add(`show`);
        } else {
          element.classList.add(`hidden`);
          element.classList.remove(`show`);
        }
      });

      if (filterValue.length === 0) {
        if (showMoreButton) {
          showMoreButton.classList.remove(`hidden`);
        }
        items.forEach((element) => {
          element.classList.remove(`show`);
        });
      } else {
        if (showMoreButton) {
          showMoreButton.classList.add(`hidden`);
        }
      }
    };

    const filteredElements = debounce(() => {
      getFilteredElements();
    });

    searchInput.addEventListener(`input`, filteredElements);
  };

  if (filterSearchContainers.length) {
    filterSearchContainers.forEach((element) => filteringElements(element));
  }
};
